import { Label, Input } from "@fluentui/react-components";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";
import { Column, TextFilter as TextFilterType } from "./types";

type Props = {
  column: Column;
};

export const TextFilter = ({ column }: Props) => {
  const filter = column.filter as TextFilterType;
  const { setFilter, strings, t, id } = useContext(ColumnOptionsContext);

  return (
    <div>
      <Label>{strings.textFilterLabel}</Label>
      <Input
        id={id ? `${id}-TextFilter-${column.key}` : undefined}
        value={filter.value}
        placeholder={t(column.placeholder)}
        onChange={(_, data) => {
          setFilter(column.key, {
            ...filter,
            value: data.value ?? "",
          });
        }}
      />
    </div>
  );
};
